import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { memo, useMemo } from 'react';

import { Icon } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import { Col, Row } from 'components/layout';

import { TouchpointType } from 'lib/models/touchpoint';
import { PAGE_ROUTES } from 'lib/page-routes';

import { useAttendeesFilter } from '../useAttendeesFilter';

import styles from './InDraftCard.module.scss';

export const InDraftCard: React.FC = memo(() => {
  const router = useRouter();
  const { id } = router.query;

  const [t] = useTranslation('event-dashboard');

  const { touchpoint } = useAttendeesFilter();

  const { creatable_for } = touchpoint || {};
  const isSocietyEvent = useMemo(() => {
    return creatable_for?.data.type === 'student_society';
  }, [creatable_for]);

  const editLink = useMemo(() => {
    return `${(isSocietyEvent
      ? PAGE_ROUTES.EVENTS_EDIT
      : PAGE_ROUTES.CAMPAIGNS_EDIT
    ).replace('[id]', id as string)}?step=1&type=${TouchpointType.Event}`;
  }, [id, isSocietyEvent]);

  return (
    <>
      <div className={styles.PendingInviteCard}>
        <Row align="center" justify="space-between">
          <Col>
            <Row className={styles.info}>
              <Col>
                <Icon iconName="icon_info" size="large" />
              </Col>
              <Col className={styles.infoText}>
                <p className={styles.title}>{t('in-draft.message')}</p>
              </Col>
            </Row>
          </Col>
          <Col className={styles.buttons}>
            <ButtonV3
              onClick={() => {
                router.push(editLink);
              }}
              color="primary"
              borderless
            >
              {t('common.continue')}
            </ButtonV3>
          </Col>
        </Row>
      </div>
    </>
  );
});

InDraftCard.displayName = 'InDraftCard';
